import React, { Component } from "react";
import { Button, Modal } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";

import { BsDownload } from "react-icons/bs";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Menu, MenuItem } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import { Toaster, toast } from "react-hot-toast";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AuthService from "../../session/AuthService";
import { Image } from "antd";
import { API_URL } from "../../config/app-config";

class ServiceRecordsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      OpenServiceRecord: false,
      showfinalValue: {},
      anchorEl: null,
      selectedEditData: {},
      opendeleteproductDialogue: false,
    };
  }

  componentDidMount() {
    console.log("this.props.fulldata", this.props.fulldata);
  }

  render() {
    const { showfinalValue } = this.state;

    console.log("this.state:::", this.state);

    const { fulldata } = this.props;

    if (fulldata && fulldata.length > 0) {
      const { service_type } = fulldata[0];
      console.log("service_type", service_type);
    } else {
      // Handle the case when fulldata is undefined or empty
    }

    return (
      <>
        <Modal show={this.props.show} onHide={this.props.handleClose}>
          <Modal.Header closeButton>
            <span style={{ fontSize: "15px", fontWeight: "bolder" }}>
              {this.props.machineName}
            </span>
            {AuthService.getUserTypeAdmin() !== "3" &&
              this.props.openplusIcon && (
                <AddCircleRoundedIcon
                  sx={{ color: "rgb(138, 188, 73)" }}
                  onClick={this.openFormExistingForm}
                />
              )}
          </Modal.Header>
          <Modal.Body>
            {!this.state.OpenServiceRecord && (
              <>
                {this.props.fulldata.map((e) => (
                  <>
                    <div
                      className="render-serviceRecord"
                      style={{
                        borderBottom: "1px solid #F3F3F3",
                        padding: "10px",
                      }}
                    >
                      <div className="row">
                        <div className="col-10">{e.service_title}</div>
                        <div className="col-2">
                          <>
                            <MoreHorizIcon
                              onClick={(event) =>
                                this.handleFilterClick(event, e)
                              }
                            />{" "}
                            <Menu
                              anchorEl={this.state.anchorEl}
                              open={Boolean(this.state.anchorEl)}
                              onClose={this.handleFilterClose2}
                              className="exclude-menu"
                            >
                              <MenuItem
                                onClick={() => this.handleFilterClose("edit")}
                              >
                                <EditOutlinedIcon />{" "}
                                <span className="inisde-the-action">Edit</span>
                              </MenuItem>
                              {AuthService.getUserTypeAdmin() !== "3" && (
                                <>
                                  <MenuItem
                                    onClick={() =>
                                      this.handleFilterClose("delete")
                                    }
                                  >
                                    <DeleteOutlinedIcon />{" "}
                                    <span className="inisde-the-action">
                                      Delete
                                    </span>
                                  </MenuItem>
                                </>
                              )}

                              <MenuItem
                                onClick={() => this.handleFilterClose("view")}
                              >
                                <VisibilityIcon />{" "}
                                <span className="inisde-the-action">View</span>
                              </MenuItem>
                            </Menu>
                          </>
                        </div>
                      </div>
                    </div>
                  </>
                ))}
              </>
            )}
            {this.state.OpenServiceRecord && (
              <>
                {console.log("this.state.......", this.state.showfinalValue)}
                <table style={{ width: "345px" }}>
                  <>
                    {String(showfinalValue.service_type) !== "1" && (
                      <>
                        <tr id="ServiceRecord-tr">
                          <td id="heading-tr-tag">
                            {showfinalValue.service_type !== "2"
                              ? "Odometer Reading"
                              : "Hour Meter"}
                          </td>

                          <td id="heading-tr-value-tag">
                            {showfinalValue.meterReading}
                          </td>
                        </tr>
                      </>
                    )}

                    <tr id="ServiceRecord-tr">
                      <td id="heading-tr-tag">{"Who Completed the Task"}</td>

                      <td id="heading-tr-value-tag">
                        {showfinalValue.isDealer
                          ? "Dealer"
                          : showfinalValue.personTask}
                      </td>
                    </tr>
                    <tr id="ServiceRecord-tr">
                      <td id="heading-tr-tag">
                        {"Hours taken to Complete Service"}
                      </td>

                      <td id="heading-tr-value-tag">
                        {showfinalValue.hourstoComplete}
                      </td>
                    </tr>
                    <tr id="ServiceRecord-tr">
                      <td id="heading-tr-tag">{"Date"}</td>

                      <td id="heading-tr-value-tag">
                        {showfinalValue.service_date}
                      </td>
                    </tr>
                  </>
                </table>

                <div className="service-record-content">
                  {showfinalValue.detailDescription}
                </div>
               {showfinalValue.uploadImage && <div className="service-record-record">
                  <Image
                    width={100}
                    src={`${API_URL}auth/assets/${showfinalValue.uploadImage}`}
                  />
                </div>}
                <div
                  className="download-service-record"
                  onClick={this.downloaddocument}
                >
                  <BsDownload style={{ fontSize: "23px", color: "green" }} />
                  <span id="span1">Services records From dealership</span>
                </div>
                <div className="download-service-record">
                  <BsDownload
                    style={{ fontSize: "23px", color: "green" }}
                    onClick={this.readyDocument}
                  />
                  <span id="span1">Services Records</span>
                </div>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            {/* {this.state.OpenServiceRecord && (
              <Button variant="secondary" onClick={this.deleteServiceRecord}>
                Delete
              </Button>
            )} */}

            <Button
              variant="secondary"
              onClick={
                this.state.OpenServiceRecord
                  ? this.backToList
                  : this.props.handleClose
              }
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>

        <Toaster />
      </>
    );
  }

  openFormExistingForm = () => {
    this.props.openExistingForm(this.props.fulldata[0]);
    this.props.handleClose();
  };

  handleFilterClick = (event, data) => {
    console.log("event", event, data);
    this.setState({
      anchorEl: event.target,
      selectedEditData: data,
    });
  };

  handleFilterClose2 = () => {
    this.setState({
      anchorEl: null,
    });
  };

  handleFilterClose = (getState) => {
    console.log("getState", getState);

    console.log("sttate of selected Value", this.state.selectedEditData);

    if (getState === "edit") {
      this.props.ActiveEdit(this.state.selectedEditData);
      this.handleFilterClose2();
      //  this.props.handleClose();
    } else if (getState === "delete") {
      this.setState(
        {
          anchorEl: null,
        },
        () => {
          this.props.openDeleteFunction(this.state.selectedEditData);
          this.props.handleClose();
        }
      );
    } else if (getState === "view") {
      this.props.closeopenPlusIcon();
      this.setState({
        showfinalValue: this.state.selectedEditData,
        OpenServiceRecord: true,
      });
    }
  };

  backToList = () => {
    this.setState({
      anchorEl: null,
      OpenServiceRecord: false,
    });
  };

  readyDocument = () => {
    const hostname = window.location.hostname;

    const downloadLink = document.createElement("a");
    if (hostname === "localhost") {
      downloadLink.href = `http://${hostname}:8081/auth/pdf/generate/${this.state.showfinalValue.servicerecord_Id}`;
    } else if (hostname === "farmconnect.betalearnings.com") {
      downloadLink.href = `http://farmconnect.betalearnings.com/FarmConnect/auth/pdf/generate/${this.state.showfinalValue.servicerecord_Id}`;
    } else if (hostname === "35.182.98.99") {
      downloadLink.href = `http://35.182.98.99/FarmConnect/auth/pdf/generate/${this.state.showfinalValue.servicerecord_Id}`;
    } else {
      downloadLink.href = `http://35.182.98.99/FarmConnect/auth/pdf/generate/${this.state.showfinalValue.servicerecord_Id}`;
    }
    downloadLink.download = "ServiceRecord.pdf";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  downloaddocument = () => {
    if (this.state.showfinalValue.service_file !== null) {
      const hostname = window.location.hostname;
      console.log("hostname", hostname);
      const downloadLink = document.createElement("a");
      if (hostname === "localhost") {
        downloadLink.href = `http://${hostname}:8081/auth/assets/download/${this.state.showfinalValue.service_file}`;
      } else if (hostname === "farmconnect.betalearnings.com") {
        downloadLink.href = `http://farmconnect.betalearnings.com/FarmConnect/auth/assets/download/${this.state.showfinalValue.service_file}`;
      } else if (hostname === "35.182.98.99") {
        downloadLink.href = `http://35.182.98.99/FarmConnect/auth/assets/download/${this.state.showfinalValue.service_file}`;
      } else {
        downloadLink.href = `http://35.182.98.99/FarmConnect/auth/assets/download/${this.state.showfinalValue.service_file}`;
      }
      downloadLink.download = "ServiceRecord.pdf";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } else {
      toast.error("No file has been uploaded");
    }
  };
}
export default ServiceRecordsModal;
